// src/components/common/FormField.js
import React from 'react';

const FormField = ({
  label,
  type = 'text',
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  required = false,
  error,
  className = '',
  labelClassName = '',
  inputClassName = '',
  helpText,
  disabled = false,
  ...props
}) => {
  // Generate ID if not provided
  const inputId = id || name;
  
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label
          htmlFor={inputId}
          className={`block mb-2 text-sm font-medium ${
            error ? 'text-red-600' : 'text-gray-800'
          } ${labelClassName}`}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      {type === 'textarea' ? (
        <textarea
          id={inputId}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors ${
            error
              ? 'border-red-500 bg-red-50'
              : 'border-gray-300 focus:border-primary'
          } ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''} ${inputClassName}`}
          {...props}
        />
      ) : (
        <input
          type={type}
          id={inputId}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors ${
            error
              ? 'border-red-500 bg-red-50'
              : 'border-gray-300 focus:border-primary'
          } ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''} ${inputClassName}`}
          {...props}
        />
      )}
      
      {helpText && !error && (
        <p className="mt-1 text-sm text-gray-500">{helpText}</p>
      )}
      
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default FormField;